export default __webpack_public_path__ + "static/media/expTwitter.87b38ec2.svg";